export default "__VITE_ASSET__6fbd4afe__"